import { useContext, useMemo } from 'react'
import { Box } from '@mui/material'

//components
import Modal from 'components/modal'
import GmailConnectionStart from './ModalContent/GmailConnectionStart'
import GmailConnectionFinish from './ModalContent/GmailConnectionFinish'
//constants
import { CONNECT_GMAIL_MODAL_STATE } from 'constants/index'
//contexts
import AuthContext from 'context/AuthContext'
//services
import { closeGmailConnectModal } from 'services/authService'
//types
import { ConnectGmailModalProps } from 'types'

const ConnectGmailModal = ({
  isModalDisplayed,
  hideModal,
  modalState = CONNECT_GMAIL_MODAL_STATE.START,
}: ConnectGmailModalProps) => {
  const { user } = useContext(AuthContext)

  const handleHideModal = async () => {
    if (user && modalState === CONNECT_GMAIL_MODAL_STATE.FINISH) {
      await closeGmailConnectModal(user.id)
    }
    hideModal()
  }

  const modalContent = useMemo(() => {
    switch (modalState) {
      case CONNECT_GMAIL_MODAL_STATE.START:
        return {
          title: 'Upgrade Available',
          subTitle: 'Earn rewards with every purchase!',
          content: <GmailConnectionStart hideModal={handleHideModal} />,
        }
      case CONNECT_GMAIL_MODAL_STATE.FINISH:
        return {
          title: 'Congratulations!',
          subTitle: '',
          content: <GmailConnectionFinish hideModal={handleHideModal} />,
        }
      default:
        return null
    }
  }, [modalState])

  if (!modalContent) {
    return null
  }

  return (
    <Box
      display="flex"
      onClick={(e) => {
        // stop the click event from bubbling up because there is an event listener above this that is listening for click events that will open/close Featured Games section when there is more than two active offers.  This click event is solely to open/close the modal.
        e.stopPropagation()
      }}
    >
      <Modal
        showModal={isModalDisplayed}
        hideModal={handleHideModal}
        closeButton={true}
        title={modalContent.title}
        subtitle={modalContent.subTitle}
        isCustomText={true}
        titleVariant="title"
        customPaperStyles={{ overflow: 'visible' }}
        text={
          <Box sx={{ position: 'relative' }}>
            <Box
              component="img"
              src="/images/piggy-tossing-coins.png"
              alt="Piggy Bank"
              sx={{
                position: 'absolute',
                top: {
                  xs: '-275px', // For mobile screens
                  sm: '-375px', // For tablet screens
                  md: '-375px', // For desktop screens
                },
                left: '50%',
                transform: 'translateX(-50%)',
                width: {
                  xs: '150px', // Smaller on mobile
                  sm: '200px', // Medium on tablet
                  md: '225px', // Full size on desktop
                },
                height: 'auto',
                zIndex: 2,
                overflow: 'visible',
              }}
            />
            {modalContent.content}
          </Box>
        }
      />
    </Box>
  )
}

export default ConnectGmailModal
